.root {
  position: fixed;
  z-index: 10;
  display: flex;
  flex-direction: column;
  min-width: 180px;
  padding: 4px;
  background-color: var(--surface-default);
  border-radius: 4px;
  box-shadow: var(--elevation-moderate);
  outline: 1px solid var(--border-soft);
  font-size: 12px;
}

.item {
  display: flex;
  align-items: center;
  padding: 6px 8px;
  width: 100%;
  background: transparent;
  border: 0;
  color: var(--text-default);
  font: inherit;
  font-size: 12px;
  text-align: left;
  cursor: pointer;
  border-radius: 4px;
  white-space: nowrap;
}

.item:hover {
  background: var(--surface-hover, rgba(255, 255, 255, 8%));
}

.item.disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
